import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Check, ChevronsUpDown } from "lucide-react";
import { cn } from "@/lib/utils";

// Single-select combobox with a search field on top.
// options: [{value, label, keywords?}]
export function SearchSelect({ options, value, onChange, placeholder = "Cerca...", emptyLabel = "Seleziona", testid }) {
  const [open, setOpen] = useState(false);
  const sel = options.find((o) => o.value === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" data-testid={testid} className="h-10 w-full justify-between rounded-md font-normal">
          <span className="truncate">{sel?.label || emptyLabel}</span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[var(--radix-popover-trigger-width)] max-w-[calc(100vw-2rem)] p-0" align="start">
        <Command>
          <CommandInput placeholder={placeholder} data-testid={`${testid}-search`} />
          <CommandList>
            <CommandEmpty>Nessun risultato</CommandEmpty>
            <CommandGroup>
              {options.map((o, oi) => (
                <CommandItem key={o.value} value={`${o.label} ${o.keywords || ""} ${o.value}`} onSelect={() => { onChange(o.value); setOpen(false); }} data-testid={`${testid}-opt-${o.value}`} className={cn("items-start", oi % 2 === 1 && "bg-slate-50")}>
                  <Check className={cn("mr-2 mt-0.5 h-4 w-4 shrink-0", value === o.value ? "opacity-100" : "opacity-0")} />
                  <span className="whitespace-normal break-words leading-snug">{o.label}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
